import { render } from "./CreateReleaseDocumentationComponent.vue?vue&type=template&id=560bc206"
import script from "./CreateReleaseDocumentationComponent.vue?vue&type=script&lang=js"
export * from "./CreateReleaseDocumentationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__